<template>
  <div>
    <div class="row">

      <div class="col-6 mb-3">
        <h1>{{$t('menu.5')}}</h1>
      </div>
      <div class="col-6 mb-3 ">
        <el-button-group class="pull-right">
          <el-tooltip :content="$t('yeni')" placement="bottom">
            <el-button type="success" icon="el-icon-plus" @click="yeni"></el-button>
          </el-tooltip>
        </el-button-group>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <el-col :span="24">
          <el-table
            :data="Data.filter(data => !search || data.adi.toLowerCase().includes(search.toLowerCase()) || data.aciklama.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%">

            <el-table-column
              prop="harf"
              width="100">

              <template slot-scope="Data">
                <span class="kullanici">{{ Data.row.harf }}</span>
              </template>

            </el-table-column>

            <el-table-column
              :label="$t('cari.adi')"
              prop="adi">
            </el-table-column>

            <el-table-column
              :label="$t('cari.kategori')"
              prop="kategori">
            </el-table-column>

            <el-table-column
              :label="$t('cari.email')"
              prop="email">
            </el-table-column>

            <el-table-column
              :label="$t('cari.telefon')"
              prop="telefon">
            </el-table-column>

            <el-table-column
              :label="$t('cari.bakiye')"
              prop="bakiye">
              <template slot-scope="Data">
                <el-tag :type="Data.row.bakiye <=0 ? 'danger': 'success' ">
                  <p v-if="Data.row.bakiye >0 || Data.row.bakiye<0">{{Data.row.bakiye}}</p>
                  <p v-if="Data.row.bakiye == 0">0,00</p>
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              align="right">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="search"
                  size="mini"
                  :placeholder="$t('ara')"/>
              </template>
              <template slot-scope="scope">
                <el-tooltip :content="$t('duzenle')" placement="right">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"><i class="i-Brush"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip :content="$t('sil')" placement="right">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, Data, scope.row)"><i class="i-Folder-Trash"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

        </el-col>
      </div>
    </div>

    <el-dialog :title="$t('menu.5')" :visible.sync="modal">

      <el-form :model="CariForm" status-icon ref="CariForm" size="mini" label-width="120px">


        <el-form-item
          prop="Kategori_id"
          :label="$t('cari.kategori')"
          :rules="[
          { required: true, message: $t('bos') },
          ]">
          <el-select v-model="CariForm.Kategori_id">
            <el-option
              v-for="index in Kategori"
              :key="index.id"
              :label="index.adi"
              :value="index.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          prop="adi"
          :label="$t('cari.adi')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('bos') }]">
          <el-input v-model="CariForm.adi"></el-input>
        </el-form-item>

        <el-form-item
          prop="firma"
          :label="$t('cari.firma')"
          autocomplete="off"
          >
          <el-input v-model="CariForm.firma"></el-input>
        </el-form-item>
        <hr>
        <el-form-item
          prop="adres"
          :label="$t('cari.adres')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('bos') }]">
          <el-input type="textarea" v-model="CariForm.adres"></el-input>
        </el-form-item>

        <el-form-item
          prop="pkodu"
          :label="$t('cari.pkodu')"
          autocomplete="off"
          :rules="[
          { required: true, message: $t('bos') },
          ]">
          <el-input v-model="CariForm.pkodu"></el-input>
        </el-form-item>

        <el-form-item
          prop="sehir"
          :label="$t('cari.sehir')"
          autocomplete="off"
          :rules="[
          { required: true, message: $t('bos') },
          ]">
          <el-input v-model="CariForm.sehir"></el-input>
        </el-form-item>

        <el-form-item
          prop="email"
          :label="$t('cari.email')"
          autocomplete="off"
          :rules="[
          { required: true, message: $t('bos') },
          { type: 'email', message: $t('login.email.hata') }
          ]">
          <el-input v-model="CariForm.email"></el-input>
        </el-form-item>


        <el-form-item
          prop="telefon"
          :label="$t('cari.telefon')"
        >
          <el-input type="text" maxlength="12" show-word-limit v-model.number="CariForm.telefon"
                    autocomplete="off"></el-input>
        </el-form-item>


        <el-form-item
          :span="11"
          :label="$t('cari.faks')"
          autocomplete="off"
        >
          <el-input v-model="CariForm.faks"></el-input>
        </el-form-item>

        <hr>


        <el-form-item
          :label="$t('cari.vdairesi')"
          autocomplete="off">
          <el-input v-model="CariForm.vdairesi"></el-input>
        </el-form-item>


        <el-form-item
          :label="$t('cari.vno')"
          autocomplete="off">
          <el-input v-model="CariForm.vno"></el-input>
        </el-form-item>


        <el-form-item
          prop="id"
          autocomplete="off"
          type="hidden">
          <el-input type="hidden" :value="this.CariForm.id"></el-input>
        </el-form-item>


      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="modal = false, yenimodal = false">{{$t('iptal')}}</el-button>
        <el-button type="primary" @click="onSubmit('CariForm')">{{$t('kaydet')}}</el-button>

      </span>
    </el-dialog>
  </div>
</template>

<script>

    import notification from '../../notification';

    export default {
        data() {
            return {
                Kategori: [],
                Data: [],
                modal: false,
                search: '',
                CariForm: {
                    id: '',
                    adi: '',
                    aciklama: '',
                    Kategori_id: '',

                },

                yenimodal: false,
                formLabelWidth: '180px',
            }
        },
        methods: {

            handleEdit(index, row) {
                this.yenimodal = false
                this.CariForm = row
                this.modal = true

            },
            handleDelete(index, row, rows) {

                this.$confirm(this.$t('siluyari.0'), '', {
                    confirmButtonText: this.$t('tmm'),
                    cancelButtonText: this.$t('iptal'),
                    type: 'warning'
                }).then(() => {

                    row.splice(index, 1);
                    this.$store.dispatch("Delete", {link: 'cari', id: rows.id}).then(response => {
                        if (response.Status == 'OK') {
                            this.$message({
                                type: 'success',
                                message: this.$t('siluyari.1')
                            });
                        } else {
                            this.$message({
                                type: 'danger',
                                message: response.Status
                            });
                        }
                    });


                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('siluyari.2')
                    });
                });


            },
            CariListele() {
                this.$store.dispatch("dataver", {method: "get", url: "/cari"})
                    .then(response => {
                        console.log(response.Data)
                        if (response.Status == 'OK') {
                            this.Data = response.Data;
                        } else {

                        }
                    });
            },

            KategoriListele() {
                this.$store.dispatch("dataver", {method: "get", url: "/kategori/3"})
                    .then(response => {
                        if (response.Status == 'OK') {
                            this.Kategori = response.Data;
                            this.CariForm.Kategori_id = response.Data[0].id;
                        } else {

                        }
                    });
            },
            onSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log(this.yenimodal)
                        if (this.yenimodal == false && this.CariForm.id) {
                            const vm = this
                            this.$store.dispatch("dataver", {
                                method: 'put',
                                url: '/cari/' + this.CariForm.id,
                                data: this.CariForm
                            }).then(response => {
                                console.log(response)
                                notification.dispatch('addNotification', vm.CariForm.adi + ' adlı Carı ekledı')
                                if (response.Status == 'OK') {
                                    this.CariListele()
                                    this.modal = false
                                    this.$message({
                                        type: 'success',
                                        message: this.$t('siluyari.1')
                                    });
                                } else {

                                }
                            })

                        }
                        if (this.yenimodal == true) {

                            this.$store.dispatch("dataver", {
                                method: 'post',
                                url: '/cari/',
                                data: this.CariForm
                            }).then(response => {
                                if (response.Status == 'OK') {
                                    this.CariListele()
                                    this.modal = false
                                    this.$message({
                                        type: 'success',
                                        message: this.$t('siluyari.1')
                                    });
                                } else {

                                }
                            })

                        }

                    }
                });
            },
            yeni() {
                this.CariForm = {}
                this.yenimodal = true
                this.modal = true
            },
            a(){
                console.log(this.yenimodal)
            }
        },
        created() {
            this.KategoriListele()
            this.CariListele()

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/cari/index.vue